import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoggerService } from '@careapp/angular-sdk';

import { AppSettings } from '../../settings/app-settings.service';
import { FormCoreComponent } from '../form-core';

@Component({
  selector: 'nf-reset',
  templateUrl: 'reset-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetFormComponent extends FormCoreComponent<{ email: string }> {
  protected _disabled = false;
  protected _loading = false;
  email = new FormControl('', Validators.compose([Validators.required]));

  form: FormGroup;

  @Input()
  set disabled(val: boolean) {
    this._disabled = val;
    if (this._disabled || this._loading) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
  get disabled() {
    return this._disabled;
  }

  @Input()
  set loading(val: boolean) {
    this._loading = val;
    if (this._loading || this._disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
  get loading() {
    return this._loading;
  }

  @Input() error: string;
  @Output() login = new EventEmitter();
  constructor(public fb: FormBuilder, public logger: LoggerService, public settings: AppSettings) {
    super();
    this.form = new FormGroup({ email: this.email });
  }

  onSubmit() {
    super.onSubmit();
  }
}
